//import { configureStore as configureStoreDev } from "./configureStore.dev";
//import { configureStore as configureStoreProd } from "./configureStore.prod";

//export const configureStore = process.env.NODE_ENV !== "production"
//    ? configureStoreDev
//    : configureStoreProd;

let configureStore1 = undefined;

if (process.env.NODE_ENV !== "production") {
    configureStore1 = require("./configureStore.dev").configureStore;

} else {
    configureStore1 = require("./configureStore.prod").configureStore;
}

export const configureStore = configureStore1;
